import { ReactComponent as Key1 } from "../assets/key1.svg";
import { ReactComponent as Key2 } from "../assets/key2.svg";
import { ReactComponent as Key3 } from "../assets/key3.svg";
import { ReactComponent as Key4 } from "../assets/key4.svg";
import { ReactComponent as Key5 } from "../assets/key5.svg";
import { ReactComponent as Key6 } from "../assets/key6.svg";
import { ReactComponent as Key7 } from "../assets/key7.svg";
import { ReactComponent as Key8 } from "../assets/key8.svg";

import './Key.css';

const keySvgComponents = {
  1: Key1,
  2: Key2,
  3: Key3,
  4: Key4,
  5: Key5,
  6: Key6,
  7: Key7,
  8: Key8,
}

const Key = ({
  roundIndex,
  keyIndex,
  color,
  isSelected,
  isDisabled,
  isClickable,
  onSelect
}) => {
  const KeySvgComponent = keySvgComponents[keyIndex];

  return (
    <div
      className={`key${isSelected ? ' selected' : ''}${isDisabled ? ' disabled' : ''}${isClickable ? ' clickable' : ''}`}
      onClick={() => isClickable && onSelect(roundIndex, keyIndex)}
      style={{ '--color': color }}
    >
      <KeySvgComponent height={100} />
    </div>
  );
}

export default Key;